import { GlobalConfigType, setApplicationStep } from 'actions'
import cloneDeep from 'clone-deep'
import { IS_NEXYS_COMPANY, IS_PRODUCTION, LoanFieldProps } from 'config'
import { store } from 'reducers'
import { isEmpty, removeComma } from 'utils'

import { BorrowerSeperator } from '../config'
import { borrowerMenuKey } from '../util'

export const creditValidate = (borrowerSeperator: BorrowerSeperator, updateStore = false, afterRemoved = false) => {
  const { borrower, step, globalConfigReducer } = store.getState()

  const loanFieldProperties = globalConfigReducer[GlobalConfigType.LoanFields] as LoanFieldProps
  if (((loanFieldProperties as any)['visibility'] || {})['credit'] === false) {
    return true
  }

  let success = true
  const data = borrower[borrowerSeperator]
  if (!data || !data.creditRequestType || !data.equifax || !data.experian || !data.transunion) success = false

  if (afterRemoved) success = false
  if (updateStore) {
    let application = cloneDeep(step.application)
    const key = borrowerMenuKey(borrowerSeperator, 'credit')
    application[key] = success ? 1 : -1
    store.dispatch(setApplicationStep(application))
  }

  return success
}

const getMiddleValue = (a: number, b: number, c: number) => {
  let zeros = 0
  if (a <= 0) zeros += 1
  if (b <= 0) zeros += 1
  if (c <= 0) zeros += 1

  const minValue = Math.min(a, b, c)
  const maxValue = Math.max(a, b, c)

  let middleValue = a + b + c - minValue - maxValue
  if (zeros >= 2) middleValue = maxValue

  return middleValue
}

export const isSameStructureApplicationCreditScore = () => {
  const { loan, borrower } = store.getState()
  let { estimatedCreditScore, isNoScore } = loan
  if (isNoScore) return { same: true, value: 0, error: '' }
  estimatedCreditScore = removeComma(estimatedCreditScore)

  let middleValue = 0

  Object.keys(borrower).forEach((borrowerSep) => {
    const { equifax, experian, transunion } = borrower[borrowerSep]
    if (!equifax || !experian || !transunion) return
    const value = getMiddleValue(removeComma(equifax), removeComma(experian), removeComma(transunion))
    if (middleValue == 0) middleValue = value
    else middleValue = Math.min(middleValue, value)
  })

  const priceScore = borrower[BorrowerSeperator.BORROWER].priceScore

  if (!isEmpty(priceScore)) {
    const options = getPriceScoreOptions()

    if (options.includes(priceScore)) middleValue = priceScore
  }

  if (middleValue == estimatedCreditScore) return { same: true, value: middleValue, error: '' }
  return { same: false, value: middleValue, error: `Credit Score does not match Credit Report (${middleValue})` }
}

export const closingCostEstimateIsSameFeeWorksheet = () => {
  const { loan, loanDetail } = store.getState()
  // Enable to Pull Closing Cost Estimate
  if (!IS_PRODUCTION || IS_NEXYS_COMPANY) {
    if (removeComma(loan.closingCostEstimate) != removeComma(loanDetail.closingCostEstimate))
      return { same: false, error: `The Fee Worksheet does not match the input estimate.` }
    else return { same: true, error: '' }
  } else return { same: true, error: '' }
}

export const getPriceScoreOptions = () => {
  const { borrower } = store.getState()
  const options: string[] = []

  Object.keys(borrower).forEach((borrowerSep) => {
    ;['equifax', 'transunion', 'experian'].forEach((key) => {
      if (!isEmpty(borrower[borrowerSep][key]) && !options.includes(borrower[borrowerSep][key]))
        options.push(borrower[borrowerSep][key])
    })
  })

  options.sort()

  return options
}
